import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import settingsProvider from "src/providers/settings-provider";
import type {
	CurrencySetting,
	SystemSetting,
	UpdateCurrencySettingRequest,
	UpdateSystemSettingRequest,
} from "src/types";

const settingsQueries = {
	listSystemSettings: () => {
		return useQuery<SystemSetting[]>({
			queryKey: ["settings", "system"],
			queryFn: () => settingsProvider.listSystemSettings(),
			staleTime: 60_000,
		});
	},

	listCurrencySettings: (enabledOnly = false) => {
		return useQuery<CurrencySetting[]>({
			queryKey: ["settings", "currency", { enabledOnly }],
			queryFn: () => settingsProvider.listCurrencySettings(enabledOnly),
			staleTime: 60_000,
		});
	},

	updateSystemSetting: () => {
		const queryClient = useQueryClient();

		return useMutation({
			mutationFn: ({
				key,
				data,
			}: {
				key: string;
				data: UpdateSystemSettingRequest;
			}) => settingsProvider.updateSystemSetting(key, data),
			onSuccess: () => {
				queryClient.invalidateQueries({ queryKey: ["settings", "system"] });
			},
		});
	},

	updateCurrencySetting: () => {
		const queryClient = useQueryClient();

		return useMutation({
			mutationFn: ({
				ticker,
				data,
			}: {
				ticker: string;
				data: UpdateCurrencySettingRequest;
			}) => settingsProvider.updateCurrencySetting(ticker, data),
			onSuccess: () => {
				queryClient.invalidateQueries({ queryKey: ["settings", "currency"] });
			},
		});
	},
};

export default settingsQueries;
